export const PERSONAL_API_OVERRIDE_KEY = 'starGridApiBaseUrl';

/** Authenticated calls may target the shared alpha API or one of its personal subdomains. */
const alphaApiOrigin = (override: string, fallback: string): string | undefined => {
  const url = new URL(override);
  const alphaHost = new URL(fallback).hostname;
  const allowedHost = url.hostname === alphaHost || url.hostname.endsWith(`.${alphaHost}`);
  if (!allowedHost || url.protocol !== 'https:' || url.port || url.username || url.password) return undefined;
  if (url.pathname !== '/' || url.search || url.hash) return undefined;
  return url.origin;
};

/** Resolve once on page load. Beta/prod never access the browser override. */
export const resolveStarGridApiBaseUrl = (fallback: string, isNonProd: boolean, configuredOverride?: string): string => {
  if (!isNonProd || typeof window === 'undefined') return fallback;
  try {
    const override = configuredOverride?.trim() || window.localStorage.getItem(PERSONAL_API_OVERRIDE_KEY)?.trim();
    return override ? alphaApiOrigin(override, fallback) ?? fallback : fallback;
  } catch {
    return fallback;
  }
};
